import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    proposalInfoState: null,
};

export const proposalInfoSlice = createSlice({
    name: "proposalInfo",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setProposalInfo: (state, action) => {
            state.proposalInfoState = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { setProposalInfo } = proposalInfoSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.loader.value)`
export const selectProposalInfo = (state) => state.proposalInfo;
export const selectProposalInfoState = (state) => state.proposalInfo.proposalInfoState;

export default proposalInfoSlice.reducer;
